<button
	(click)="callAction()"
	class="btn {{ buttonStyle ? buttonStyle : 'btn-primary' }}"
	type="{{ type }}"
	[ngClass]="styles"
	[tabIndex]="tabIndex"
	data-style="slide-right"
	[disabled]="disabled || loading">
	{{ text | translate }}
</button>
